import { render } from "./TruckView.vue?vue&type=template&id=39a35582"
import script from "./TruckView.vue?vue&type=script&lang=js"
export * from "./TruckView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__